'use strict';

import { message } from 'antd';
import FetchData from '@ezviz/FetchData';
import intl from 'react-intl-universal';
export const GET_DATA_LIST = 'GET_DATA_LIST';
export const UPDATE_LOADING_STATUS = 'UPDATE_LOADING_STATUS';
export const UPDATE_PANNEL_MODAL = 'UPDATE_PANNEL_MODAL';
export const UPDATE_PANNEL_MODAL_LOADING_STATUS = 'UPDATE_PANNEL_MODAL_LOADING_STATUS';


const IOT_CONFIG_DOMAIN = '/iot/config';

message.config({
    top: 300,
    maxCount: 3,
});

export function updateLoadingStatus(loading) {
    return (dispatch, getState) => {
        dispatch({
            type: UPDATE_LOADING_STATUS,
            loading,
        });
    };
}

// 更新弹出框状态（显示、隐藏）
export function updatePannelModal(modalItme = null, visible = false, opType = 'ADD') {
    return (dispatch, getState) => {
        dispatch({
            type: UPDATE_PANNEL_MODAL,
            modalItme,
            visible,
            opType,
        });
    }
}

export function updatePannelModalLoadingStatus(loading) {
    return (dispatch, getState) => {
        dispatch({
            type: UPDATE_PANNEL_MODAL_LOADING_STATUS,
            loading,
        });
    }
}

/**
 * 获取面板列表
 * @param {*} param
 */
export function getList(param) {
    return (dispatch, getState) => {
        const { pageStart } = getState().managePannel;
        const defaultParam = {
            pageStart: pageStart,
            pageSize: 10,
            all: true
        }
        const req = Object.assign({}, defaultParam, param);
        dispatch(updateLoadingStatus(true));
        const fetchData = new FetchData(`${IOT_CONFIG_DOMAIN}/api/iot/support/v3/panel/page`, {
            method: 'POST',
            body: req,
        });
        fetchData.then((res) => {
            dispatch(updateLoadingStatus(false));
            if (res.code == 200) {
                dispatch({
                    type: GET_DATA_LIST,
                    dataList: res.data || [],
                    total: res.page.total,
                    pageStart: req.pageStart
                });
            } else {
                message.error(res.msg || intl.get('commmon.operate.retry'));
            }
        }).catch(e => {
            message.error(intl.get('commmon.operate.retry'));
            dispatch(updateLoadingStatus(false));
        })
    };
}

/**
 * 新增/编辑面板
 * @param {*} param
 * @param {*} type： ’ADD'新增面板 'EDIT'编辑面板
 */
export function updataPannel(param, type, callback, failback) {
    return (dispatch, getState) => {
        const defaultParam = {
            firstCategory: '',
            secondCategory: '',
            panelName: '',
            config: '',
            picture: ''
        }
        let METHOD = 'POST'
        let url = `${IOT_CONFIG_DOMAIN}/api/iot/support/v3/panel/add`;
        if (type == 'EDIT') {
            METHOD = 'PUT'
            url = `${IOT_CONFIG_DOMAIN}/api/iot/support/v3/panel/update`;
        }
        const req = Object.assign({}, defaultParam, param);
        dispatch(updateLoadingStatus(true));
        const fetchData = new FetchData(url, {
            method: METHOD,
            body: req,
        });
        fetchData.then((res) => {
            dispatch(updateLoadingStatus(false));
            if (res.code == 200) {
                dispatch(getList());
                callback && callback();
            } else {
                message.error(res.msg || intl.get('commmon.operate.retry'));
                failback && failback();
            }
        }).catch(e => {
            message.error(intl.get('commmon.operate.retry'));
            dispatch(updateLoadingStatus(false));
            failback && failback();
        })
    };
}

/**
 * 删除面板
 * @param {*} param
 * @param {*} type
 * @param {*} callback
 * @param {*} failback
 */
export function deletePannel(param, type, callback, failback) {
    return (dispatch, getState) => {
        const defaultParam = {
            panelId: '',
        }
        const req = Object.assign({}, defaultParam, param);
        const url = `${IOT_CONFIG_DOMAIN}/api/iot/support/v3/panel/delete`;
        dispatch(updateLoadingStatus(true));
        const fetchData = new FetchData(url, {
            method: 'DELETE',
            body: req,
        });
        fetchData.then((res) => {
            dispatch(updateLoadingStatus(false));
            if (res.code == 200) {
                dispatch(getList());
                callback && callback();
            } else {
                message.error(res.msg || intl.get('commmon.operate.retry'));
                failback && failback();
            }
        }).catch(e => {
            message.error(intl.get('commmon.operate.retry'));
            dispatch(updateLoadingStatus(false));
            failback && failback();
        })
    };
}

